<template>
  <q-btn stack flat stretch
    v-show="laterals && laterals.length > 0"
    :icon="!showLateral ? 'panorama' : 'panorama_horizontal'"
    :label="!isLabel ? '' : !showLateral ? $t('names.image') : $t('names.panorama')"
    @click="activateLateral"
  >
    <q-tooltip>
      {{ !showLateral ? $t('tools.panorama.enableLateral') : $t('tools.panorama.enablePano') }}
    </q-tooltip>
  </q-btn>
</template>

<script>
import { ClosePopup, QBtn, QTooltip } from 'quasar'
import { mapState } from 'vuex'

export default {
  components: {
    QBtn, QTooltip
  },
  directives: {
    ClosePopup
  },
  computed: {
    ...mapState({
      laterals: state => state.panorama.laterals,
      showLateral: state => state.panorama.showLateral
    }),
    isLabel () {
      return this.isHeader && this.$q.screen.gt.md
    }
  },
  methods: {
    activateLateral () {
      const isActive = this.$store.state.panorama.showLateral
      if (!isActive) {
        this.$store.dispatch('panorama/selectLateral')
      } else {
        this.$store.commit('panorama/setSelectedLateral', null)
      }
      this.$store.commit('panorama/setShowLateral', !isActive)
    }
  }
}
</script>
